import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ServerUnavailable from "./components/pages/ServerUnavailable/ui/ServerUnavailable";
import Login from "./components/pages/auth/Login";
import Requests from "./components/pages/Requests/Requests";
import Request from "./components/pages/Request/Request";
import ManagerAddressees from "./components/ProrabMenu/ManagerAddresesses/ManagerAddresesses";
import ManagerProrabs from "./components/ProrabMenu/ManagerProrabs/ManagerProrabs";
import ManagerNewProrab from "./components/ProrabMenu/ManagerNewProrab/ManagerNewProrab";
import ManagerAddresessesSelect from "./components/ProrabMenu/ManagerAddresessesSelect/ManagerAddresessesSelect";
import { useRegisterDevice } from "./hooks/useRegisterDevice";

import { Toaster } from "react-hot-toast";
import axios from "axios";
import ClientInfo from "./components/ClientInfo/ClientInfo";

export const enHSInstance = axios.create({
  baseURL: `https://api-erkon.tech/mobile/hs/ObmenMP/`,
  timeout: 15000,
  headers: {
    token: localStorage.getItem("tokenMANAGER"),
  },
});

function App() {
  const theme = localStorage.getItem("theme");
  document.documentElement.dataset.theme = theme;

  useRegisterDevice();

  return (
    <>
      <Toaster containerStyle={{ zIndex: 999999 }} />
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="requests" element={<Requests />} />
          <Route path="requests/addresses" element={<ManagerAddressees />} />
          <Route
            path="requests/addresses/prorabs"
            element={<ManagerProrabs />}
          />
          <Route
            path="requests/addresses/prorabs/newProrab"
            element={<ManagerNewProrab />}
          />
          <Route
            path="requests/addresses/prorabs/newProrab/addressSelection"
            element={<ManagerAddresessesSelect />}
          />
          <Route path="requests/confirm" element={<Request />} />
          <Route path="clientInfo" element={<ClientInfo />} />

          <Route
            path="*"
            element={
              localStorage.getItem("tokenMANAGER") ? (
                <Navigate to="requests" />
              ) : (
                <Navigate to="login" />
              )
            }
          />
          <Route path="server-error" element={<ServerUnavailable />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
